import { Component, OnInit } from '@angular/core';
import { SelectedCustomerService, AuthService } from 'gung-standard';
import { DeliveryLocationsJeevesComponent, DeliveryLocationsService } from 'gung-standard-jeeves';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { first, mergeMap } from 'rxjs';
import { forkJoin, of } from 'rxjs';

@Component({
    selector: 'colmec-delivery-locations-jeeves',
    templateUrl: './colmec-delivery-locations-jeeves.component.html',
    styleUrls: ['./colmec-delivery-locations-jeeves.component.scss'],
    standalone: false
})
export class ColmecDeliveryLocationsJeevesComponent extends DeliveryLocationsJeevesComponent implements OnInit {
  customerHasLp = false;
  customerMethodCode = null;

  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected deliveryLocationsService: DeliveryLocationsService,
    protected formBuilder: FormBuilder,
    protected authService: AuthService,
    protected datePipe: DatePipe
  ) {
    super(selectedCustomerService, deliveryLocationsService, formBuilder, authService);
  }

  ngOnInit() {
    this.onNextBtnClicked.subscribe(_ => this.handleNextButtonClicked());
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(
        first(),
        mergeMap(selectedCustomer =>
          forkJoin([
            of(selectedCustomer),
            this.deliveryLocationsService.getDeliveryLocationsForCustomer(selectedCustomer.id)
          ])
        )
      )
      .subscribe(([selectedCustomer, deliveryLocations]) => {
        this.selectedCustomer = selectedCustomer;
        if (this.selectedCustomer.extra.lp && this.selectedCustomer.extra.lp.length > 0) {
          this.customerHasLp = true;
        }
        this.initForm();
        this.deliveryLocations = [...deliveryLocations];

        if (this.selectedCustomer.extra.kus.ordlevplats1) {
          const deliveryLocation = this.deliveryLocations.find(location => {
            return location.extra.lp.ordlevplats1 === this.selectedCustomer.extra.kus.ordlevplats1;
          });
          this.deliveryLocationId = deliveryLocation.id;
        } else {
          this.deliveryLocations.unshift({
            id: this.selectedCustomer.id,
            customerId: this.selectedCustomer.id,
            name: this.selectedCustomer.name,
            extra: this.selectedCustomer.extra,
            timestamp: new Date()
          });
          this.deliveryLocationId = this.deliveryLocations[0].id;
        }
      });
  }

  protected initForm() {
    this.form = this.formBuilder.group({
      ordlevadr1: [{ disabled: true, value: this.checkout.extra.procargs.ordlevadr1 || '' }],
      ordlevadr2: [{ disabled: true, value: this.checkout.extra.procargs.ordlevadr2 || '' }],
      ordlevadr4: [{ disabled: true, value: this.checkout.extra.procargs.ordlevadr4 || '' }],
      ordlevadr3: [{ disabled: true, value: this.checkout.extra.procargs.ordlevadr3 || '' }],
      ftgpostnr: [{ disabled: true, value: this.checkout.extra.procargs.ftgpostnr || '' }],
      ordlevadrlandskod: [{ disabled: true, value: this.checkout.extra.procargs.ordlevadrlandskod || '' }]
    });
  }

  protected afterDeliveryLocationSet(deliveryLocationId: string) {
    super.afterDeliveryLocationSet(deliveryLocationId);
    if (this.customerHasLp) {
      this.customerMethodCode = this.selectedDeliveryLocation.extra.lp.levsattkod;
    }
    this.checkout.extra.procargs.ftgpostnr = this.selectedDeliveryLocation.extra.fr.ftglevpostnr;
    this.checkout.extra.procargs.ordlevadr4 = this.selectedDeliveryLocation.extra.fr.ftgpostlevadr3;
    this.checkout.extra.procargs.ordlevadr3 = this.selectedDeliveryLocation.extra.fr.ftgpostadr5;
    const procargsKeys = Object.keys(this.form.getRawValue());

    const valueMap = {};
    procargsKeys.forEach(key => {
      valueMap[key] = this.checkout.extra.procargs[key] || '';
    });

    this.form.setValue(valueMap);
    this.initForm();
  }

  protected assignPostalCodeAndCity(postalCode: string, city: string): void {
    // Default behavior is wrong here
  }

  protected handleNextButtonClicked(): void {
    if (this.form.invalid) {
      return;
    }

    this.assignPostalCodeAndCity(this.postalCode, this.city);
    this.assignFormValues(this.form, this.formOh);
    this.stepDone.emit(this.checkout);
  }

  protected assignFormValues(form: FormGroup, formOh: FormGroup) {
    const rawFormData = form.getRawValue();
    this.checkout.extra.procargs = {
      ...this.checkout.extra.procargs,
      ...rawFormData
    };
    if (this.customerHasLp) {
      this.checkout.extra.customerMethodCode = this.customerMethodCode;
    }
  }
}
